import helper from 'helpers/steinerHelper';
import apiClient from 'apis/security';

export default helper.createApi('management/permission', apiClient, {
    limit: 'perPage',
    page: 'page',
    filter: 'q'
});
